import { FC, useEffect, useState } from "react";
import { Card, CardContent, CardHeader, TextField } from "@mui/material";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import { useGameDataContext } from "@context/GameDataContext";
import { gameState } from "@/services/gameState";

const SetSelector: FC = () => {
  const { challenge, setSet } = useSelectedChallengeContext();
  const { game } = useGameDataContext();
  const currentSet = gameState("currentSet");

  const [setInternal, setSetInternal] = useState<number | undefined>(
    challenge?.set ||
      currentSet?.setNumber ||
      (game?.challenges.length
        ? Math.max(...(game?.challenges.map((c) => c.set) || [1]))
        : 1),
  );

  useEffect(() => {
    if (setInternal) {
      setSet(setInternal);
    }
  }, [setInternal]);

  return (
    <Card variant="elevation" elevation={5} sx={{ width: "120px", mx: 2 }}>
      <CardHeader
        title={"Satz"}
        slotProps={{ title: { variant: "subtitle1", align: "center" } }}
        sx={{ pb: 0 }}
      />
      <CardContent>
        <TextField
          id="set"
          variant="outlined"
          type={"text"}
          autoComplete="off"
          slotProps={{
            input: {
              inputProps: {
                style: {
                  textAlign: "center",
                },
              },
            },
          }}
          value={setInternal}
          onChange={(event) => {
            const input = /\d?/.exec(event.target.value)?.[0];
            if (!input) {
              setSetInternal(undefined);
            } else {
              setSetInternal(
                Number.parseInt(input || input === "0" ? input : "1"),
              );
            }
          }}
        />
      </CardContent>
    </Card>
  );
};

export default SetSelector;
